export default __webpack_public_path__ + "static/media/step1.cfd8118d.webp";